import { z } from 'zod'

// Defaults are for production. Override in .env if needed in dev.
const envSchema = z.object({
  VITE_SENTRY_DSN: z
    .string()
    .default(
      'https://e802646045618743f8ff74f8193fae80@o4508981578104832.ingest.us.sentry.io/4511297272348672',
    ),
})

export const env = envSchema.parse(import.meta.env)
